export const dataGaleria = [
  {
    id: 1,
    nameItem: 1,
    titleItem:
      "GALERÍA FOTOGRÁFICA 2026",
    flushID: "2",
    children: [
      {
        id: 1,
        subChildren: [
          {
            id: 1,
            title: "GALERÍA FOTOGRÁFICA 2026",
            pdfUrl:
              "https://itetlax.org.mx/assets/img/OIC/fotos_2026.pdf",
          },
        ],
      },
    ],
  },
];


export const dataEstructuraOrganica = [
  {
    id: 1,
    titleItem: "ESTRUCTURA ORGÁNICA ITE",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/1.pdf",
  },
  {
    id: 2,
    titleItem: "ESTRUCTURA ORGÁNICA OIC",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/2.pdf",
  },
];

export const dataNormatividad = [
  {
    id: 1,
    titleItem:
      "REGLAMENTO DEL ÓRGANO INTERNO DE CONTROL DEL INSTITUTO TLAXCALTECA DE ELECCIONES",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/normatividad/1.pdf",
  },
  {
    id: 2,
    titleItem:
      "LINEAMIENTOS DE AUDITORIA DEL ÓRGANO INTERNO DE CONTROL DEL ITE",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/normatividad/2.pdf",
  },
  {
    id: 3,
    titleItem:
      "LINEAMIENTOS PARA LA INVESTIGACION Y TRÁMITE DE LOS PROCEDIMIENTOS DE RESPONSABILIDAD ADMINISTRATIVA DE LOS SERVIDORES PUBLICOS DEL INSTITUTO TLAXCALTECA DE ELECCIONES",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/normatividad/3.pdf",
  },
  {
    id: 4,
    titleItem:
      "LEY DE TRANSPARENCIA Y ACCESO A LA INFORMACIÓN PÚBLICA DEL ESTADO DE TLAXCALA",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/normatividad/4.pdf",
  },
  {
    id: 5,
    titleItem: "CONSTITUCIÓN PÓLITICA EU MEXICANOS",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/normatividad/5.pdf",
  },
  {
    id: 6,
    titleItem: "CONSTITUCIÓN POLÍTICA DEL ESTADO LIBRE Y SOBERANO DE TLAXCALA",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/normatividad/6.pdf",
  },
  {
    id: 7,
    titleItem:
      "LEY DE INSTITUCIONES Y PROCEDIMIENTOS ELECTORALES PARA EL ESTADO DE TLAXCALA",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/normatividad/7.pdf",
  },
  {
    id: 8,
    titleItem: "LEY FISCALIZACIÓN OFS",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/normatividad/8.pdf",
  },
  {
    id: 9,
    titleItem: "LG RESPONSABILIDADES ADMINISTRATIVAS 22 11 21",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/normatividad/9.pdf",
  },
  {
    id: 10,
    titleItem: "CÓDIGO FINANCIERO PARA EL ESTADO DE TLAXCALA Y SUS MUNICIPIOS",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/normatividad/10.pdf",
  },
  {
    id: 11,
    titleItem: "LEY DE ARCHIVOS DEL ESTADO DE TLAXCALA",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/normatividad/11.pdf",
  },
  {
    id: 12,
    titleItem: "LEY DE COORDINACIÓN FISCAL",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/normatividad/12.pdf",
  },
  {
    id: 13,
    titleItem: "LEY DEL IMPUESTO SOBRE LA RENTA",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/normatividad/13.pdf",
  },
  {
    id: 14,
    titleItem:
      "LEY DEL PROCEDIMIENTO ADMINISTRATIVO DEL ESTADO DE TLAXCALA Y SUS MUNICIPIOS",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/normatividad/14.pdf",
  },
];

export const dataPOA = [
  {
    id: 1,
    titleItem: "PROGRAMA OPERATIVO ANUAL 2022",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/POA/POA_2022.pdf",
  },
  {
    id: 2,
    titleItem: "PROGRAMA OPERATIVO ANUAL 2023",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/POA/POA_2023.pdf",
  },
  {
    id: 3,
    titleItem: "PROGRAMA OPERATIVO ANUAL 2024",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/POA/POA_2024.pdf",
  },
  {
    id: 4,
    titleItem: "PROGRAMA OPERATIVO ANUAL 2025",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/POA/POA_2025.pdf",
  },
  {
    id: 5,
    titleItem: "PROGRAMA OPERATIVO ANUAL 2026",
    typeDocument: "excel",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/POA/POA_2026.xlsx",
  },
];

export const dataSemblanza = [
  {
    id: 1,
    titleItem: "CURRICULUM VITAE – LICDA. SUSANA MANZANO SÁNCHEZ",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/semblanza/CV_SMS.pdf",
  },
];

export const dataDeclaracionPatrimonial = [
  {
    id: 1,
    titleItem: "LINK PARA PRESENTACIÓN DE LA DECLARACIÓN PATRIMONIAL",
    typeDocument: "link",
    linkItem: "https://PDE.SAETLAX.ORG/",
  },
  {
    id: 2,
    titleItem: "TUTORIAL DE LLENADO DE DECLARACIÓN",
    typeDocument: "video",
    linkItem: "https://youtu.be/hM8Wu_0s0ys",
  },
  {
    id: 3,
    titleItem: "TIPO DE DECLARACIÓN",
    typeDocument: "img",
    linkItem: "https://itetlax.org.mx/assets/img/OIC/dec_pat.jpg",
  },
  {
    id: 4,
    titleItem: "DECLARACIÓN PATRIMONIAL PRESENTACIÓN INFORMATIVA",
    typeDocument: "link",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/presentacion_informativa.pptx",
  },
  {
    id: 5,
    titleItem: "POSTER DE DECLARACIÓN PATRIMONIAL",
    typeDocument: "img",
    linkItem: "https://itetlax.org.mx/assets/img/OIC/poster.png",
  },
];

export const dataCodigoEtica = [
  /* {
    id: 1,
    titleItem: "CÓDIGO DE ÉTICA",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/CE/1.pdf",
  }, */
  {
    id: 2,
    titleItem: "CÓDIGO DE ÉTICA (REFORMA 2026)",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/CE/3.pdf",
  },
];

export const dataInformes = [
  {
    id: 1,
    titleItem: "PRIMER INFORME ANUAL DE ACTIVIDADES 2022",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/informes/2022.pdf",
  },
  {
    id: 2,
    titleItem: "SEGUNDO INFORME ANUAL DE ACTIVIDADES 2023",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/informes/2023.pdf",
  },
  {
    id: 3,
    titleItem: "TERCER INFORME ANUAL DE ACTIVIDADES 2024",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/informes/2024.pdf",
  },
];

export const dataConvenios = [
  {
    id: 1,
    titleItem:
      "CONVENIO CON LA SECRETARIA EJECUTIVA DEL SISTEMA ANTICORRUPCION DEL ESTADO DE TLAXCALA 2022",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/convenios/2022.pdf",
  },
  {
    id: 2,
    titleItem:
      "CONVENIO CON LA SECRETARIA EJECUTIVA DEL SISTEMA ANTICORRUPCION DEL ESTADO DE TLAXCALA 2023",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/convenios/2023.pdf",
  },
  {
    id: 3,
    titleItem:
      "CONVENIO CON LA SECRETARIA EJECUTIVA DEL SISTEMA ANTICORRUPCION DEL ESTADO DE TLAXCALA 2024",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/convenios/2024.pdf",
  },
  {
    id: 4,
    titleItem:
      "CONVENIO MODIFICATORIO AL CONVENIO DE COLABORACIÓN PARA UTILIZAR EL SISTEMA DE CAPTURA DE EVOLUCIÓN PATRIMONIAL 2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/convenios/CONVENIO_MODIFICATORIO.pdf",
  },
];

export const dataResoluciones = [
  /* {
    id: 1,
    titleItem:
      "CONVENIO CON LA SECRETARIA EJECUTIVA DEL SISTEMA ANTICORRUPCION DEL ESTADO DE TLAXCALA 2022",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/convenios/2022.pdf",
  },
  {
    id: 2,
    titleItem:
      "CONVENIO CON LA SECRETARIA EJECUTIVA DEL SISTEMA ANTICORRUPCION DEL ESTADO DE TLAXCALA 2023",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/convenios/2023.pdf",
  },
  {
    id: 3,
    titleItem:
      "CONVENIO CON LA SECRETARIA EJECUTIVA DEL SISTEMA ANTICORRUPCION DEL ESTADO DE TLAXCALA 2024",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/convenios/2024.pdf",
  },
  {
    id: 4,
    titleItem:
      "CONVENIO MODIFICATORIO AL CONVENIO DE COLABORACIÓN PARA UTILIZAR EL SISTEMA DE CAPTURA DE EVOLUCIÓN PATRIMONIAL 2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/convenios/CONVENIO_MODIFICATORIO.pdf",
  }, */
];


export const dataAcuerdosOIC = [
  /* {
    id: 1,
    titleItem: "Acuerdo OIC/01/2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/1.0_2026.pdf",
    subDocuments: [
      {
        id: 1,
        title: "Anexo 1",
        typeDocument: "pdf",
        link: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/1.1_2026.pdf",
      },
      {
        id: 2,
        title: "Formato Excel",
        typeDocument: "excel",
        link: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/1.2_2026.xlsx",
      },
    ],
  }, */

  {
    id: 1,
    titleItem: "ITE-OIC-A-001-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-A-001-2026.pdf",
    subDocuments: [],
  },
  {
    id: 2,
    titleItem: "ITE-OIC-A-002-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-A-002-2026.pdf",
    subDocuments: [],
  },
  {
    id: 3,
    titleItem: "ITE-OIC-A-003-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-A-003-2026.pdf",
    subDocuments: [],
  },
  {
    id: 4,
    titleItem: "ITE-OIC-A-004-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-A-004-2026.pdf",
    subDocuments: [],
  },
  {
    id: 5,
    titleItem: "ITE-OIC-A-005-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-A-005-2026.pdf",
    subDocuments: [],
  },
  {
    id: 6,
    titleItem: "ITE-OIC-A-006-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-A-006-2026.pdf",
    subDocuments: [],
  },
  {
    id: 7,
    titleItem: "ITE-OIC-A-007-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-A-007-2026.pdf",
    subDocuments: [],
  },
  {
    id: 8,
    titleItem: "ITE-OIC-A-008-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-A-008-2026.pdf",
    subDocuments: [],
  },
  {
    id: 11,
    titleItem: "ITE-OIC-A-011-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-A-011-2026.pdf",
    subDocuments: [],
  },
  {
    id: 12,
    titleItem: "ITE-OIC-A-012-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-A-012-2026.pdf",
    subDocuments: [],
  },
];

export const dataAcuerdosOICAG = [
  /* {
    id: 1,
    titleItem: "Acuerdo OIC/01/2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/1.0_2026.pdf",
    subDocuments: [
      {
        id: 1,
        title: "Anexo 1",
        typeDocument: "pdf",
        link: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/1.1_2026.pdf",
      },
      {
        id: 2,
        title: "Formato Excel",
        typeDocument: "excel",
        link: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/1.2_2026.xlsx",
      },
    ],
  }, */

  {
    id: 1000,
    titleItem: " ITE-OIC-TRANSP-001-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-TRANSP-001-2026.pdf",

    subDocuments: [],
  },
  
  {
    id: 3000,
    titleItem: " ITE-OIC-TRANSP-003-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-TRANSP-003-2026.pdf",

    subDocuments: [],
  },
  {
    id: 50000,
    titleItem: " ITE-OIC-TRANSP-005-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-TRANSP-005-2026.pdf",

    subDocuments: [],
  },
  {
    id: 13000,
    titleItem: " ITE-OIC-TRANSP-013-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-TRANSP-013-2026.pdf",

    subDocuments: [],
  },

  {
    id: 1,
    titleItem: " ITE-OIC-TRANSP-AC-001-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-TRANSP-AC-001-2026.pdf",

    subDocuments: [],
  },
  {
    id: 2,
    titleItem: " ITE-OIC-TRANSP-AC-002-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-TRANSP-AC-002-2026.pdf",

    subDocuments: [],
  },
  {
    id: 3,
    titleItem: " ITE-OIC-TRANSP-AC-003-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-TRANSP-AC-003-2026.pdf",

    subDocuments: [],
  },
  {
    id: 4,
    titleItem: " ITE-OIC-TRANSP-AC-004-2026",
    typeDocument: "pdf",
    linkItem: "https://itetlax.org.mx/assets/pdf/OIC/acuerdos/ITE-OIC-TRANSP-AC-004-2026.pdf",

    subDocuments: [],
  },
];